/* eslint-disable @nrwl/nx/enforce-module-boundaries */
// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ImportDetailRowsResultDto, PrimaNotaDto } from '@ideapa/common-dto';
import { FilterValue, PagedResultDto } from '@ideapa/common-interfaces';

import { of, tap } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class PrimaNotaApiClient extends BaseCRUDApiClient<PrimaNotaDto> {
  baseUrl = this.config.apiEndpoint + '/prima-nota';

  private _pagedCacheWithTotals: Map<
    string,
    {
      data: PagedResultDto<PrimaNotaDto> & {
        totaleDare: number;
        totaleAvere: number;
      };
      expiration: Date;
    }
  > = new Map();

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  override clearCache() {
    this._pagedCache.clear();
    this._pagedCacheWithTotals.clear();
  }

  // canRegister(body: { codiceTipologia: string }) {
  //   return this.http.post<boolean>(`${this.baseUrl}/can-register`, body);
  // }

  // canDelete(body: { codiceTipologia: string }) {
  //   return this.http.post<boolean>(`${this.baseUrl}/can-delete`, body);
  // }

  registrazioneAutomatica(codiceTipologia: string) {
    this._pagedCache.clear();
    this._pagedCacheWithTotals.clear();
    return this.http.post(this.baseUrl + '/registrazione-automatica', {
      codiceTipologia: codiceTipologia,
    });
  }

  deleteRecordTipologia(codiceTipologia: string) {
    this._pagedCache.clear();
    this._pagedCacheWithTotals.clear();
    return this.http.get(
      `${this.baseUrl}/delete-record-tipologia/${codiceTipologia}`
    );
  }

  getPagedByTypeWithTotals(
    take: number,
    skip: number,
    orderBy?: { [field: string]: 'asc' | 'desc' },
    filters?: FilterValue[],
    join?: string[],
    areDomainUserFiltersDisabled?: boolean,
    isEntitySelectionLimited?: boolean,
    areEnteAnnoFiltersDisabled?: boolean
  ) {
    const mappedFilters = this.buildPagedFilters(filters);
    const request = {
      skip,
      take,
      orderBy,
      filters: mappedFilters,
      join,
      areDomainUserFiltersDisabled: areDomainUserFiltersDisabled,
      isEntitySelectionLimited: isEntitySelectionLimited,
      areEnteAnnoFiltersDisabled: areEnteAnnoFiltersDisabled,
    };

    // console.log('request: ', request);
    const cacheKey = JSON.stringify(request);
    console.log('cacheKey: ', cacheKey);
    const cached = this._pagedCacheWithTotals.get(cacheKey);
    if (cached) {
      if (cached.expiration > new Date()) {
        return of(cached.data);
      } else {
        this._pagedCacheWithTotals.delete(cacheKey);
      }
    }

    return this.http
      .post<
        PagedResultDto<PrimaNotaDto> & {
          totaleDare: number;
          totaleAvere: number;
        }
      >(`${this.baseUrl}/pagedwithtotals`, request)
      .pipe(
        tap((result) =>
          this._pagedCacheWithTotals.set(cacheKey, {
            data: result,
            expiration: new Date(
              Date.now() + 60 * 1000 * this.CACHE_EXPIRATION_MIN
            ),
          })
        )
      );
  }

  importExcelFile(file: File) {
    this._pagedCache.clear();
    this._pagedCacheWithTotals.clear();
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ImportDetailRowsResultDto>(
      this.baseUrl + '/import-excel',
      fd
    );
  }
}
